import { useEffect, useRef, useState } from "react";
import { Music, VolumeX } from "lucide-react";

export const BackgroundMusic = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const audio = ref.current;
    if (!audio) return;
    audio.volume = 0.85;

    const tryPlay = () => {
      audio
        .play()
        .then(() => setPlaying(true))
        .catch(() => {});
    };

    // Browsers block audio before a user gesture — start on the first one
    tryPlay();
    const events = ["pointerdown", "keydown", "touchstart", "wheel", "scroll"];
    const onFirst = (e) => {
      // Let the toggle button control playback itself — don't double-fire
      if (e.target && e.target.closest && e.target.closest('[data-testid="bg-music-toggle"]')) return;
      tryPlay();
      events.forEach((ev) => window.removeEventListener(ev, onFirst));
    };
    events.forEach((ev) => window.addEventListener(ev, onFirst));
    return () => events.forEach((ev) => window.removeEventListener(ev, onFirst));
  }, []);

  const toggle = () => {
    const audio = ref.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      audio
        .play()
        .then(() => setPlaying(true))
        .catch(() => {});
    }
  };

  return (
    <>
      <audio ref={ref} src="/ambient.mp3" loop preload="auto" data-testid="bg-music-audio" />
      <button
        data-testid="bg-music-toggle"
        onClick={toggle}
        aria-label={playing ? "Turn background music off" : "Turn background music on"}
        title={playing ? "Music on — tap to mute" : "Tap for soft music"}
        className={`fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full border border-white/15 bg-black/70 px-4 py-2.5 text-white shadow-lg backdrop-blur transition-colors duration-300 hover:bg-[#7C3AED] ${
          playing ? "" : "animate-pulse"
        }`}
      >
        {playing ? <Music size={16} /> : <VolumeX size={16} />}
        <span className="text-[10px] font-semibold uppercase tracking-[0.2em]">
          {playing ? "Music On" : "Music"}
        </span>
      </button>
    </>
  );
};

export default BackgroundMusic;
